import { ChangeDetectorRef, Component } from '@angular/core';
import { Vkc } from '@reflact/reflactportal';
import { FaqService } from 'src/app/shared/services/faq.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { MandantService } from 'src/app/shared/services/mandant.service';

@Component({
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  standalone: false
})
export class WelcomeComponent {
  public serviceStatementVkcs: Vkc[] = [];
  /** Startseiten-Meldung des Mandanten (HTML, wird per [innerHTML] von Angular bereinigt). */
  public homeMessage = '';

  constructor(public loginService: LoginService, public faqService: FaqService, private mandantService: MandantService, private cdr: ChangeDetectorRef) {
    this.mandantService.getHomeMessage().then(message => {
      this.homeMessage = message;
      this.cdr.detectChanges();
    }).catch(() => { });
    if (this.loginService.loggedInMandantUser?.permissions.includes('admin')) {
      this.faqService.getAccountInfo().then(r => {
        this.serviceStatementVkcs = this.faqService.serviceStatementVkcs;
      })
    }
  }

  /** Tageszeit-abhängige Anrede für den Dashboard-Header. */
  public get greeting(): string {
    const hour = new Date().getHours();
    if (hour < 11) return $localize`:@@welcomeGreetingMorning:Guten Morgen`;
    if (hour < 18) return $localize`:@@welcomeGreetingDay:Hallo`;
    return $localize`:@@welcomeGreetingEvening:Guten Abend`;
  }

}
